import dayjs from "dayjs"

/**
 * `/crm/lead-notes/` sends `created` as a naive UTC wall clock
 * ("2026-10-03 05:29:11"). Pinning it to UTC turns it into the zoned instant
 * the Activity formatter converts into the account's timezone; read as-is it
 * would be taken as the browser's local time.
 */
const noteCreatedInstant = (raw: string | null | undefined): string | null => {
  if (!raw) return null
  const instant = dayjs.utc(raw)
  return instant.isValid() ? instant.toISOString() : null
}

export { noteCreatedInstant }
